import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import Button from 'components/Button'
import Icon from 'components/Icon'
import Input from 'components/Input'
import Range from 'components/Range'
import DropdownInput from 'components/DropdownInput'
import styles from './Preview.scss'
import messages from './messages'

const iconLibrary = [
  'arrowDown',
  'arrowUp',
  'bear',
  'bell',
  'cart',
  'checked',
  'close',
  'collapse',
  'columns',
  'economy',
  'expand',
  'filters',
  'info',
  'listIcon',
  'map',
  'nonFiler',
  'placePin',
  'businesses',
  'search',
  'selectArrow',
  'settings',
  'share',
  'dashboard',
  'unchecked',
  'underReport',
]

const options = [
  { label: 'Grapes', value: 'grapes' },
  { label: 'Mango', value: 'mango' },
  { label: 'Strawberry', value: 'strawberry' },
]

export default function Preview() {
  const [dropdownSelections, setDropdownSelections] = useState([])

  return (
    <div className={styles.container}>
      <h1>
        <FormattedMessage {...messages.header} />
      </h1>

      <h2>Buttons</h2>

      <h3>Primary</h3>
      <Button buttonType='icon' onClick={() => console.info('clicked')} title='Button 1'>
        <Icon name='map' size='regular'>
          Show Map
        </Icon>
      </Button>
      <Button buttonType='icon' disabled onClick={() => console.info('clicked')} title='Button 1'>
        <Icon name='map' size='regular'>
          Show Map
        </Icon>
      </Button>
      <Button buttonType='secondary-icon' onClick={() => console.info('clicked')} title='Button 1'>
        <Icon name='map' size='regular'>
          Show Map
        </Icon>
      </Button>

      <h3>Primary Outline</h3>
      <Button buttonType='secondary-icon' outline onClick={() => console.info('clicked')} title='Button 2'>
        <Icon name='map' size='regular'>
          Show Map
        </Icon>
      </Button>

      <h3>Link</h3>
      <Button href='http://webiya.co.il' title='Button Link'>
        Link
      </Button>

      <hr />

      <h2>Inputs</h2>

      <h3>Text</h3>
      <Input type='text' placeholder='Placeholder' />

      <h3>Select</h3>
      <Input type='select'>
        <option>1</option>
        <option>2</option>
        <option>3</option>
      </Input>

      <h3>Search</h3>
      <Input type='search' placeholder='Simple input' />

      <h3>Checkbox</h3>
      <Input type='checkbox' />

      <hr />

      <h3>Dropdown</h3>
      <DropdownInput
        options={options}
        selections={dropdownSelections}
        onChange={value => setDropdownSelections(value)}
        dropdownHeader='select...'
        allItemsAreSelected='all items are selected.'
        selectAll='select all'
        search='search'
        labelledBy='select'
      />

      <hr />
      <div style={{ display: 'inline-flex', flexDirection: 'column' }}>
        <h3>Indicators</h3>
        <Icon name='indicator-physical' size='regular'>
          physical
        </Icon>
        <Icon name='indicator-employees' size='regular'>
          Employees
        </Icon>
        <Icon name='indicator-online-marketing' size='regular'>
          Online marketing target
        </Icon>
        <Icon name='indicator-collection-a' size='small'>
          indicator-collection-a
        </Icon>
        <Icon name='indicator-collection-b' size='small'>
          indicator-collection-b
        </Icon>
        <Icon name='indicator-collection-c' size='small'>
          indicator-collection-c
        </Icon>
        <Icon name='indicator-collection-d' size='small'>
          indicator-collection-d
        </Icon>

        <h3>Bigger indicators on the map</h3>

        <Icon name='indicator-physical' size='large' />
        <Icon name='indicator-employees' size='large' />
        <Icon name='indicator-online-marketing' size='large' />
      </div>

      <hr />

      <div className={styles.iconsLibrary}>
        <h3 className={styles.header}>Icon Library</h3>
        <ul className={styles.iconsList}>
          {iconLibrary.map(icon => (
            <li key={icon} className={styles.iconItem}>
              <h5>{icon}:</h5>
              <Icon name={icon} size='small' />
              <Icon name={icon} size='regular' />
              <Icon name={icon} size='large' />
            </li>
          ))}
        </ul>
      </div>

      <hr />

      <h3>Range input</h3>
      <Range minValue={0} maxValue={20} value={{ min: 5, max: 12 }} onChange={val => console.info(val)} />
    </div>
  )
}
